import { FunctionComponent, useMemo } from 'react'
import { TaskDocumentStepSelectProps } from './TaskDocumentStepSelect.model'
import { Icon, SelectInput, Tag, TooltipWrapper } from '../../../../../shared'
import {
  TASK_DOCUMENT_STEP_ICON,
  TASK_DOCUMENT_STEP_LABEL,
  TASK_DOCUMENT_STEP_OPTIONS,
} from '../../TaskTableRow.model'
import styles from './TaskDocumentStepSelect.module.scss'
import { TaskDocumentStep } from '../../../../../../model/Task'
import { addInfo } from '../../../../../../store/message'
import { useActionDispatch } from '../../../../../../hooks/utils'

export const TaskDocumentStepSelect: FunctionComponent<TaskDocumentStepSelectProps> = ({
  documentStep,
  isEditModeEnabled,
  setDocumentStep,
}) => {
  const dispatchInfo = useActionDispatch(addInfo)

  const documentStepOptions = useMemo(() => {
    if (!documentStep || TASK_DOCUMENT_STEP_OPTIONS.some((opt) => opt.value === documentStep)) {
      return TASK_DOCUMENT_STEP_OPTIONS
    }
    return [
      ...TASK_DOCUMENT_STEP_OPTIONS,
      {
        value: documentStep,
        label: TASK_DOCUMENT_STEP_LABEL[documentStep] ?? documentStep,
      },
    ]
  }, [documentStep])

  const documentStepValue = useMemo(
    () => documentStepOptions.find((opt) => documentStep === opt.value),
    [documentStep, documentStepOptions],
  )

  const handleSelectInputStep = (value: TaskDocumentStep) => {
    if (!TASK_DOCUMENT_STEP_OPTIONS.some((opt) => opt.value === value) && value !== documentStep) {
      dispatchInfo(`L'action a bien été ajoutée.`)
    }
    setDocumentStep(value)
  }

  return (
    <div className={styles.container}>
      {isEditModeEnabled ? (
        <SelectInput
          placeholder="Action"
          options={documentStepOptions}
          value={documentStepValue}
          onSelect={(selectedOption) => handleSelectInputStep(selectedOption.value)}
          testId="task-document_step"
          allowCustomOption
        />
      ) : (
        <Tag key={documentStep} ellipsis={false} testId="task-document_step">
          <div className={styles.displayValueWrapper}>
            <div className={styles.iconWrapper}>
              {documentStep && (
                <Icon size="nano" icon={TASK_DOCUMENT_STEP_ICON[documentStep] ?? 'infoCircle'} />
              )}
            </div>
            <div>
              <TooltipWrapper
                content={
                  <div className={styles.tooltipWrapperContent}>
                    {documentStep ? TASK_DOCUMENT_STEP_LABEL[documentStep] ?? documentStep : ''}
                  </div>
                }
                pointerDirection="bottom"
              >
                <div className={styles.tooltipChildrenWrapper}>
                  {documentStep ? TASK_DOCUMENT_STEP_LABEL[documentStep] ?? documentStep : ''}
                </div>
              </TooltipWrapper>
            </div>
            <div className={styles.iconSelectWrapper}>
              <Icon size="femto" icon="chevron" />
            </div>
          </div>
        </Tag>
      )}
    </div>
  )
}
